import { render, staticRenderFns } from "./CRButtonToggle.vue?vue&type=template&id=fc1a0a4c&scoped=true"
import script from "./CRButtonToggle.vue?vue&type=script&lang=js"
export * from "./CRButtonToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1a0a4c",
  null
  
)

export default component.exports